import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Turma } from './turma';
import { environment } from '../../../environments/environment';
import { UsuarioTurmaVinculoDto } from './usuario-turma-vinculo.dto';
import { Pagina } from './pagina';

@Injectable({
  providedIn: 'root'
})
export class TurmaService {

  private apiUrl = `${environment.api}/turmas`;

  constructor(private http: HttpClient) {}

  // Listar com paginação
/**
 * `GET /turmas` → `PageTurmaDto`.
 *
 * `TAB-01` — ordenação no servidor; `CTR-12` — parâmetro vazio não entra na query.
 */
listar(page: number, size: number, filtro?: string, sort?: string | null): Observable<Pagina<Turma>> {
  let params = new HttpParams()
    .set('page', page)
    .set('size', size);

  if (filtro && filtro.trim() !== '') {
    params = params.set('filtro', filtro);
  }
  if (sort) {
    params = params.set('sort', sort);
  }

  return this.http.get<Pagina<Turma>>(this.apiUrl, { params });
}


  // Buscar por id
  buscarPorId(id: string): Observable<Turma> {
    return this.http.get<Turma>(`${this.apiUrl}/${id}`);
  }

  // Criar
  criar(turma: Turma): Observable<Turma> {
    return this.http.post<Turma>(this.apiUrl, turma);
  }

  // Atualizar
  atualizar(id: string, turma: Turma): Observable<Turma> {
    return this.http.put<Turma>(`${this.apiUrl}/${id}`, turma);
  }

  /** GET binário: planilha .xlsx com matrículas (catequizandos) da turma */
  exportarMatriculasExcel(turmaId: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${turmaId}/export/matriculas-excel`, {
      responseType: 'blob',
    });
  }

  /** Usuários com acesso à turma (vínculo catequista etc.) */
  listarUsuariosTurma(turmaId: string): Observable<UsuarioTurmaVinculoDto[]> {
    return this.http.get<UsuarioTurmaVinculoDto[]>(
      `${this.apiUrl}/${encodeURIComponent(turmaId)}/usuarios`,
    );
  }

  /**
   * POST /turmas/{id}/usuarios — libera o acesso do usuário à turma
   * (passa a aparecer no `GET /turmas-usuario/minhas` dele). Idempotente no backend.
   */
  vincularUsuarioTurma(turmaId: string, usuarioId: string): Observable<UsuarioTurmaVinculoDto> {
    return this.http.post<UsuarioTurmaVinculoDto>(
      `${this.apiUrl}/${encodeURIComponent(turmaId)}/usuarios`,
      { usuarioId },
    );
  }

  /** DELETE /turmas/{id}/usuarios/{usuarioId} — remove o vínculo (o usuário não é excluído). */
  desvincularUsuarioTurma(turmaId: string, usuarioId: string): Observable<void> {
    return this.http.delete<void>(
      `${this.apiUrl}/${encodeURIComponent(turmaId)}/usuarios/${encodeURIComponent(usuarioId)}`,
    );
  }
}